import Skeleton from "@mui/material/Skeleton";
import { styled } from "@mui/material/styles";
import noop from "lodash/noop";

import { ProductSectionWrapper } from "./ProductSectionWrapper";

const ProductOverviewSectionTitleSkeleton = styled(Skeleton)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    flexDirection: "column",
}));

export function ProductOverviewSectionSkeleton() {
    return (
        <ProductSectionWrapper id="x" onVisibilityChange={noop} withSectionFadeUpAnimation={false} scrollMarginTop={0}>
            <Skeleton variant="rectangular" width={150} height={32} />
            <ProductOverviewSectionTitleSkeleton>
                {[98, 93, 100].map((width, index) => (
                    <Skeleton key={index} variant="rectangular" width={`${width}%`} height={20} />
                ))}
            </ProductOverviewSectionTitleSkeleton>
        </ProductSectionWrapper>
    );
}
